import NoPermissionPage from '@pbt/pbt-portal-ui/src/components/common/NoPermissionPage'

export const GENERIC_ROUTES = [
  { component: NoPermissionPage, path: '/403' },
]
